import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-wa-media-preview',
    templateUrl: './wa-media-preview.component.html',
    styleUrls: ['./wa-media-preview.component.scss'],
})
export class WaMediaPreviewComponent {
    @Input() type: string = '';
    @Input() url: string = '';
    public showVideoModal: boolean = false;
    public currentVideoUrl: string = '';
    constructor() {}

    openVideo(url: string | undefined): void {
        if (!url) return;
        this.currentVideoUrl = url;
        this.showVideoModal = true;
        document.body.style.overflow = 'hidden';
    }

    closeVideo(): void {
        this.showVideoModal = false;
        this.currentVideoUrl = '';
        document.body.style.overflow = '';
    }
}
